/**
 * @stable
 */
export interface Link {
    url?: string;
    target?: 'self' | 'top' | 'parent' | null;
    attributes?: { [attr: string]: string };
}

export class AuthDetails {
    authCode: string = '';
    authFlag: boolean = false;
    cashierType: CashierType | undefined;
}

export enum CashierType {
    MainCashier = 'MainCashier',
    BetSlipQd = 'BetSlipQd',
    QdOverlay = 'QdOverlay',
}
